export default "__VITE_ASSET__dfe7f17b__$_#icon-remove__"